import { ACTION_CENTER_API_PATH } from 'constants/actionCenter';
import { ActionCenterSummaryType, MailboxConnectionActionItemsResponseType } from 'types/actionCenter';

import axios from '../config/axiosPrivate';

export const getActionCenterSummary = async (): Promise<ActionCenterSummaryType> => {
  const response = await axios.get(ACTION_CENTER_API_PATH.SUMMARY);
  return response.data;
};

export const getMailboxConnectionActionItems = async (): Promise<MailboxConnectionActionItemsResponseType> => {
  const response = await axios.get(ACTION_CENTER_API_PATH.MAILBOX_CONNECTIONS);
  return response.data;
};
